import React, { useCallback } from 'react'
import { observer } from 'mobx-react'

import useInject from "~/hooks/useInject"
import DisplayInputContainer from './DisplayInputContainer'
import SimpleInput from '~/components/Form/SimpleInput'
import * as PhoneNumberTools from '~/utilities/phoneNumber'
import * as StringTools from '~/utilities/string'

const mapStore = store => ({
  user: store.auth.user,
  auth: store.auth,
})

const PhoneNumber = props => {
  const { user, auth } = useInject(mapStore)
  const { isEditing } = props
  const phoneNumberError = user.validateDisplayMessage('phoneNumber')
  const placeholder = "(555) 555-5555"

  const handleChange = useCallback(targetKey => event => {
    const input = event.target.value
    const digitInput = StringTools.removeNonDigits(input)
    user.changeKey(targetKey, digitInput)
    auth.setIsUpdatingPhoneNumber(true)
  }, [user])

  return (
    <DisplayInputContainer
      value={PhoneNumberTools.AsYouTypeFormatter(user.phoneNumber)}
      isEditing={isEditing}
      label="Phone Number"
      placeholderText={placeholder}
      error={phoneNumberError}
    >
      <SimpleInput
        id="phoneNumber"
        name="phoneNumber"
        value={PhoneNumberTools.AsYouTypeFormatter(user.phoneNumber)}
        onChange={handleChange('phoneNumber')}
        error={phoneNumberError}
      />
    </DisplayInputContainer>
  )
}

export default observer(PhoneNumber)
